import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap'

import { UtilCommonModule } from 'common/util/module'
import { LocaleModule } from 'common/locale/module'

import { MediaTagComponent } from './components/mediaTag.component'
import { MediaTagsInputComponent } from './components/mediaTagsInput.component'

@NgModule({
  imports: [
    CommonModule,
    UtilCommonModule,
    LocaleModule.forChild(),
    FormsModule,
    ReactiveFormsModule,
    NgbTypeaheadModule,
  ],
  declarations: [
    MediaTagComponent,
    MediaTagsInputComponent,
  ],
  exports: [
    MediaTagComponent,
    MediaTagsInputComponent,
  ],
})
export class MediaTagsModule { }

export default MediaTagsModule
